import React, { useEffect, useState } from "react";
import { Routes, Route, useLocation, useNavigate } from "react-router-dom";
import "./CSS/Final.css";
import "./CSS/Colors.css";
import Home from "./Component/Home";
import Footer from "./Component/Footer";
import Header from "./Component/Header";
import ProductSinglePage from "./Component/ProductSinglePage";
import Cart from "./Component/Cart";
import Checkout from "./Component/Checkout";
import ContactUs from "./Component/Contact";
import PrivacyPolicy from "./Component/PrivacyPolicy";
import RefundPolicy from "./Component/RefundPolicy";
import TermsAndConditions from "./Component/TermsAndConditions";
import InquiryForm from "./Component/EnquiryForm";
import ScrollToTop from "./Component/ScrollToTop";
import Login from "./Component/Login";
import Register from "./Component/Register";
import ResetPassword from "./Component/ResetPassword";
import MyAccount from "./Component/MyAccount";
import PaymentSuccess from "./Component/Paymentsuccess";
import Product from "./Component/Products";
import decryptCookieData from "./Component/Functions/decryptCookieData";
import axios from "axios";
import {
  listenToForegroundMessages,
  requestFCMToken,
} from "./Component/utils/firebaseUtils";
import Track from "./Component/Track";
import PrivateRoute from "./Component/PrivateRoute";
import CategoryDetails from "./Component/CategoryDetailPage";
import FloatingCartButton from "./Component/FloatingCartButton";
import ShippingPolicy from "./Component/ShippingPolicy";
import AboutUs from "./Component/AboutUs";
import AdmissionForm from "./Component/AdmissionForm";
import ProductNewCard from "./Component/ProductCard/ProductNewCard";
import Coursed from "./Component/ProductCard/Courses";
import PaymentSuccessAd from "./Component/PaymentSuccessAd";
import PaymentFailedAd from "./Component/PaymentFailedAd";
import MobileBottomNav from "./Component/MobileBottomNav";
import Centers from "./Component/Centers";
import PaymentFailed from "./Component/PaymentFailed";
import AdmissionFormStep2 from "./Component/AdmissionFormStep2";

const App = () => {
  const [cartItemsLength, setCartItemLength] = useState(0);
  const navigate = useNavigate();
  const userData =
    JSON.parse(localStorage.getItem("2xgxgshdugyywerw12gh")) || "";
  const url = process.env.REACT_APP_API_URL;
  const [cartButtons, setCartButtons] = useState([]);
  const [paybutton, setPayButtons] = useState([]);
  const [metaData, setMetaData] = useState({});
  const [user, setUser] = useState({})

  const paymentOption = async () => {
    try {
      const response = await fetch(
        `${url}/paybutton/${process.env.REACT_APP_PERFUME_ID}`
      );
      const res = await response.json();
      setPayButtons(res.data);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    const user = JSON.parse(localStorage.getItem("2xgxgshdugyywerw12gh")) || "";
    if (user && user.user_id) {
      fetchCart(user.user_id);
    } else {
      const guestCart = JSON.parse(localStorage.getItem("guest_cart")) || [];
      setCartItemLength(guestCart.length);
    }
  }, []);

  const fetchCart = async (user_id) => {
    try {
      const response = await fetch(`${url}/cart/${user_id}`);
      const result = await response.json();
      if (!result.isError) {
        setCartItemLength(result.data.length);
      } else {
        console.error("Failed to fetch cart");
      }
    } catch (error) {
      console.error("Fetch cart error:", error);
      console.error("Error fetching cart");
    }
  };

  const location = useLocation();

  const userLoggedIn = userData && userData.user_id;
  const hideSidebarRoutes = ["/login", "/register"];
  const shouldHideSidebar =
    hideSidebarRoutes.includes(location.pathname) || !userLoggedIn;

  const fetchData = async () => {
    try {
      const response = await axios.get(
        `${url}/registeruser/single/${userData.user_id}`
      );
      // setProfile(response.data);
      if (response.status === 200) {
        localStorage.setItem(
          "2xgxgshdugyywerw12gh",
          JSON.stringify(response.data)
        );
      }
      if (response.status === 201) {
        try {
          // Send logout request to backend to clear cookies
          // await fetch("http://localhost:8000/loginuser/logout", {
          //     method: "POST",
          //     credentials: "include", // ✅ ensures cookies are sent
          // });

          localStorage.removeItem("2xgxgshdugyywerw12gh");

          // Optional: redirect or reload
          // navigate("/login")
          // window.location.href = "/login"; // Or navigate to login
        } catch (err) {
          console.error("Logout failed:", err);
        }
      }
    } catch (error) {
      console.error("Error fetching location:", error);
    }
  };

  const [fcmToken, setfcmToeken] = useState(null);

  useEffect(() => {
    const fetchFcmToken = async () => {
      try {
        const token = await requestFCMToken();
        setfcmToeken(token);
      } catch (error) {
        console.error("error getting token ", error);
      }
    };
    fetchFcmToken();
    listenToForegroundMessages();
  }, []);

  useEffect(() => {
    if (fcmToken && userLoggedIn) {
      const saveToken = async () => {
        try {
          await axios.post(`${url}/firebase/register-token`, {
            user_id: userData.user_id,
            deviceToken: fcmToken,
          });
        } catch (error) {
          console.error("Failed to save FCM token:", error);
        }
      };
      saveToken();
    }
  }, [fcmToken, userLoggedIn]);

  useEffect(() => {
    if (userData && userData.user_id) {
      fetch(`${url}/registeruser/single/${userData.user_id}`)
        .then((response) => response.json())
        .then((data) => {
          if (data.message === "User not found") {
            // User does not exist in backend, remove from localStorage
            localStorage.removeItem("2xgxgshdugyywerw12gh");
            console.warn("User not found. Removed from localStorage.");
          } else {
          }
        })
        .catch((err) => {
          console.error("Error fetching user:", err);
        });
    }
  }, []);

  const cartOption = async () => {
    try {
      const response = await fetch(
        `${url}/button/${process.env.REACT_APP_PERFUME_ID}`
      );
      const res = await response.json();
      setCartButtons(res.data);
    } catch (error) {
      console.log(error);
    }
  };

  const MetafetchData = async () => {
    try {
      const response = await axios.get(
        `${url}/meta/${process.env.REACT_APP_PERFUME_ID}`
      );
      const res = response?.data;
      if (!res.isError) {
        let scripts = [];

        // case 1: Array of strings
        if (Array.isArray(res.data.scripts)) {
          scripts = res.data.scripts.map((s) => {
            if (!s) return "";
            if (typeof s !== "string") return "";
            const match = s.match(/src=["'](.*?)["']/);
            return match?.[1] || s.trim(); // keep raw if no src
          });
        }

        // case 2: Stringified JSON
        else if (typeof res.data.scripts === "string") {
          try {
            const parsed = JSON.parse(res.data.scripts);
            if (Array.isArray(parsed)) {
              scripts = parsed.map((s) => {
                if (typeof s !== "string") return "";
                const match = s.match(/src=["'](.*?)["']/);
                return match?.[1] || s.trim();
              });
            }
          } catch (err) {
            console.warn("Script JSON parse error", err);
          }
        }

        const cleanMeta = {
          ...res.data,
          scripts: scripts,
        };

        setMetaData(cleanMeta); // for display
        // for editing
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    if (userData && userData.user_id) {
      fetchData();
    }
    cartOption();
    MetafetchData();
  }, []);

  useEffect(() => {
    if (metaData) {
      // Title
      if (metaData.title) document.title = metaData.title;

      // Description
      let descTag = document.querySelector('meta[name="description"]');
      if (!descTag) {
        descTag = document.createElement("meta");
        descTag.name = "description";
        document.head.appendChild(descTag);
      }
      descTag.content = metaData.description || "";

      // Keywords
      let keywordTag = document.querySelector('meta[name="keywords"]');
      if (!keywordTag) {
        keywordTag = document.createElement("meta");
        keywordTag.name = "keywords";
        document.head.appendChild(keywordTag);
      }
      keywordTag.content = metaData.keywords || "";

      // Author
      let authorTag = document.querySelector('meta[name="author"]');
      if (!authorTag) {
        authorTag = document.createElement("meta");
        authorTag.name = "author";
        document.head.appendChild(authorTag);
      }
      authorTag.content = metaData.author || "";

      // Favicon
      if (metaData.icon) {
        const existingLink = document.querySelector("link[rel*='icon']");
        const link = document.createElement("link");
        link.rel = "icon";
        link.href = `${url}/Images/Meta/${metaData.icon}`;

        if (existingLink) {
          document.head.removeChild(existingLink);
        }
        document.head.appendChild(link);
      }

      // External Scripts
      // External Scripts
      if (Array.isArray(metaData.scripts)) {
        metaData.scripts.forEach((script) => {
          if (!script || typeof script !== "string") return;
          const exists = document.querySelector(`script[src="${script}"]`);
          if (!exists) {
            const scriptTag = document.createElement("script");
            scriptTag.type = "text/javascript";
            scriptTag.src = script;
            scriptTag.async = true;
            // scriptTag.onload = () => console.log(`${script} loaded);
            // scriptTag.onerror = () => console.error(Failed to load script: ${script});
            document.body.appendChild(scriptTag);
          }
        });
      }
    }
  }, [metaData]);

  // useEffect(() => {
  //     if (userData && userData.user_id) {
  //         fetchData();
  //     }
  //     cartOption();
  // }, []);

  const fetchUserData = async () => {
    try {
      const profileRes = await fetch(`${url}/register/single/${process.env.REACT_APP_PERFUME_ID}`);
      const res = await profileRes.json();
      const profileData = res.users
      setUser(profileData)
    } catch (error) {
      console.log(error)
    }
  }

  useEffect(() => {
    paymentOption();
    fetchUserData();
  }, []);

  return (
    <>
      <Header cartItemsLength={cartItemsLength} cartButtons={cartButtons} />
      <Routes>
        <Route
          path="/"
          element={
            <Home
              cartItemsLength={cartItemsLength}
              setCartItemLength={setCartItemLength}
              fetchCart={fetchCart}
              cartButtons={cartButtons}
            />
          }
        />
        <Route
          path="/course"
          element={
            <Coursed
              cartItemsLength={cartItemsLength}
              setCartItemLength={setCartItemLength}
              fetchCart={fetchCart}
              cartButtons={cartButtons}
            />
          }
        />
        <Route
          path="/products"
          element={
            <ProductNewCard
              cartItemsLength={cartItemsLength}
              setCartItemLength={setCartItemLength}
              fetchCart={fetchCart}
              cartButtons={cartButtons}
            />
          }
        />
        <Route
          path="/product"
          element={
            <Product
              cartItemsLength={cartItemsLength}
              setCartItemLength={setCartItemLength}
              fetchCart={fetchCart}
              cartButtons={cartButtons}
            />
          }
        />
        <Route
          path="/category-detail/:name"
          element={
            <CategoryDetails
              cartItemsLength={cartItemsLength}
              setCartItemLength={setCartItemLength}
              fetchCart={fetchCart}
              cartButtons={cartButtons}
            />
          }
        />
        <Route
          path="/product/:name/:id"
          element={
            <ProductSinglePage
              cartItemsLength={cartItemsLength}
              setCartItemLength={setCartItemLength}
              fetchCart={fetchCart}
              cartButtons={cartButtons}
            />
          }
        />
        <Route
          path="/cart"
          element={
            <Cart
              cartItemsLength={cartItemsLength}
              setCartItemLength={setCartItemLength}
              fetchCart1={fetchCart}
              paybutton={paybutton}
            />
          }
        />
        <Route
          path="/checkout"
          element={
            <PrivateRoute>
              <Checkout paybutton={paybutton} user={user}/>
            </PrivateRoute>
          }
        />
        <Route path="/contact" element={<ContactUs />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/shipping-and-delivery" element={<ShippingPolicy />} />
        <Route path="/refund-policy" element={<RefundPolicy />} />
        <Route path="/terms-and-conditions" element={<TermsAndConditions />} />
        <Route path="/enquiry-form" element={<InquiryForm />} />
        <Route path="/login" element={<Login fetchCart={fetchCart} />} />
        <Route path="/register" element={<Register fetchCart={fetchCart}/>} />
        <Route path="/about" element={<AboutUs />} />
        <Route path="/reset" element={<ResetPassword />} />
        <Route path="/admission-form" element={<AdmissionForm />} />
        <Route
          path="/admission-form-step-2"
          element={
            <AdmissionFormStep2
              cartItemsLength={cartItemsLength}
              setCartItemLength={setCartItemLength}
              fetchCart={fetchCart}
              cartButtons={cartButtons}
            />
          }
        />
        <Route
          path="/my-account"
          element={
            <PrivateRoute>
              <MyAccount cartButtons={cartButtons} />
            </PrivateRoute>
          }
        />
        <Route
          path="/payment-success/:id"
          element={
            <PrivateRoute>
              <PaymentSuccess fetchCart={fetchCart} />
            </PrivateRoute>
          }
        />
        <Route path="/centers" element={<Centers />} />
        <Route
          path="/payment-failed/:id"
          element={
            <PrivateRoute>
              <PaymentFailed />
            </PrivateRoute>
          }
        />
        <Route
          path="/payment-successad/:id"
          element={
            <PrivateRoute>
              <PaymentSuccessAd fetchCart={fetchCart} />
            </PrivateRoute>
          }
        />
        <Route
          path="/payment-failedad/:id"
          element={
            <PrivateRoute>
              <PaymentFailedAd />
            </PrivateRoute>
          }
        />
        <Route
          path="/track/:id"
          element={
            <PrivateRoute>
              <Track />
            </PrivateRoute>
          }
        />
      </Routes>
      <MobileBottomNav />
      <Footer />
      <ScrollToTop />
      <FloatingCartButton count={cartItemsLength} cartButtons={cartButtons} />
    </>
  );
};

export default App;
